export default __webpack_public_path__ + "static/media/Homepage-Background-1.b8809432.jpg";